export const MODAL_KEYS = {
  remesas: "remesas",
  pagos: "pagos",
}

export const getModalSetup = (
  showDelete: $TSMigrationFixMe,
  setShowDelete: $TSMigrationFixMe,
  handleDeleteRemesa: $TSMigrationFixMe,
  handleDeletePago: $TSMigrationFixMe,
  concepto: $TSMigrationFixMe,
  t: $TSMigrationFixMe
) => {
  const MODAL_SETUP = {
    [MODAL_KEYS.remesas]: {
      delete: handleDeleteRemesa,
      setShow: setShowDelete,
      show: showDelete,
      image: "remesas",
      msj: `${t("remesas.questionMsg")}`,
      title: `${t("remesas.titleMin")}`,
    },
    [MODAL_KEYS.pagos]: {
      delete: handleDeletePago,
      setShow: setShowDelete,
      show: showDelete,
      image: "pagos",
      msj: `${t("pagoCobro.questionMsgInit")}${concepto}${t(
        "pagoCobro.questionMsgFinal"
      )}`,
      title: `${t("pagoCobro.titleMin")}`,
    },
  }
  return MODAL_SETUP
}
